import React from 'react'
import { Setters } from 'src/features/atoms/glove/japan/Components'
import { OrderPageTemplate } from 'src/Components/Domain/OrderPageTemplate'
import { youthReducer } from 'src/features/atoms/glove/japan/slice/youth' // ここを Youth mitt reducerに変更
import { State, PartialAction, Model } from 'src/types'
import { useLocale } from 'src/locales/useLocale'
import { BaseModelSelector } from 'src/Components/Domain/BaseModelSelector'
import { atomsBaseModel } from 'src/features/atoms/glove/japan/constants/baseModel'
import { useRouter } from 'next/router'
import { atomsYouthFilterLogic } from 'src/features/atoms/glove/logic'

const YouthGlovePage: React.FC = () => {
  const { t } = useLocale()
  const router = useRouter()
  const [state, dispatch] = React.useReducer(youthReducer, t.INITIAL_STATE_YOUTH) as [State, React.Dispatch<PartialAction>]
  const [figurePanelNum, setFigurePanelNum] = React.useState(1)
  const handleFigurePanelNum = (_: any, newValue: number) => setFigurePanelNum(newValue)
  const models = atomsBaseModel(t, router)
  return (
    <OrderPageTemplate
      breadcrumbTrail={`${t.SOFT} / ATOMS / 少年用グローブ`}
      brand={'atoms'}
      {...{ figurePanelNum, state, dispatch, handleFigurePanelNum }}
    >
      <BaseModelSelector {...{ state, models, dispatch }} filterLogic={atomsYouthFilterLogic} kinds={{ label: '軟式', value: 'soft' }} />
      <Setters {...{ state, figurePanelNum, dispatch }} />
    </OrderPageTemplate>
  )
}
export default YouthGlovePage
